import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const usePostalCode = () => {
	const isClient = typeof window !== 'undefined';
	const locations = useSelector((state) => state.locations);
	const [currentPostalCode, setCurrentPostalCode] = useState('');
	const userPostalCode = isClient ? localStorage?.getItem('UserPostalCode') : null;
	const userLocation = isClient ? localStorage?.getItem('UserLocation') : null;

	useEffect(() => {
		if (userPostalCode) {
			setCurrentPostalCode(userPostalCode);
		} else if (userLocation?.postal_code) {
			setCurrentPostalCode(userLocation.postal_code);
		} else if (locations?.market?.postal_code) {
			setCurrentPostalCode(locations.market.postal_code);
		}
	}, [locations?.market?.postal_code, userLocation, userPostalCode]);

	return currentPostalCode;
};
